<template>
  <div>
    <!-- Skeleton loader -->

    <div v-if="isLoading || !bannerData[0]?.image?.length">
      <Skeletor
        class="label"
        style="margin-bottom: 0.5rem; width: 100%; height: 50vh; border-radius: 0;"
      />
    </div>

    <!-- Carousel -->
    <carousel
      v-else
      ref="myCarousel"
      class="h-50vh iview iview-group-659250a11ab17-60"
      :settings="settings"
      :wrap-around="true"
    ><template #slides>
  <slide
    v-for="(banner, j) in bannerData"
    :key="j"
    class="w-100 h-100 bg-img-cover"
  >
    <div
      class="slide_config w-100 h-100 d-flex flex-column justify-center"
      :style="getBackground(banner)"
    >
      <div class="banner-content">
        <!-- Title -->
        <div class="tp-caption large_text fw-700 banner-title">
          {{ banner.title }}
        </div>

        <!-- Button (only if category_link exists) -->
        <a
          v-if="banner.category_link"
          :href="`/products?category=${banner.category_link}`"
          class="banner-btn"
        >
          Shop Now
        </a>
      </div>
    </div>
  </slide>
</template>

      
      <template #addons>
        <Pagination v-if="bannerData.length > 1" />
      </template>
    </carousel>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeMount } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import { bannerService } from "@/services/banner.service";
import { useCommonStore } from "@/stores/common.store";

const commonStore = useCommonStore();

const isLoading = ref(false);
const settings = ref({
  itemsToShow: 1,
  snapAlign: "center",
  autoplay: 3500,
  loop: true,
  transition: 900
});
const bannerData = ref([{ image: "" }]);

const categories = computed(() => commonStore.categories ?? []);

// ✅ Safe background fallback
const getBackground = (banner) => {
  const src = banner?.image?.trim() || banner?.url?.trim() || "/images/no-image.jpg";
  return {
    backgroundImage: `url('${src}')`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };
};

const fetchSliderImages = async () => {
  isLoading.value = true;
  try {
    const res = await bannerService.getSlider();
    if (res.status === 200 && Array.isArray(res.data)) {
      const sorted = res.data.sort((a, b) => a.sortOrder - b.sortOrder);

      // ✅ normalize category_link into category id
      bannerData.value = sorted.map((banner) => {
        if (banner.category_link && typeof banner.category_link === "string") {
          const linkVal = banner.category_link.trim().toLowerCase();

          const match = categories.value.find(
            (cat) =>
              String(cat.id) === linkVal ||
              cat.name?.toLowerCase() === linkVal
          );

          if (match) {
            return { ...banner, category_link: match.id }; // replace with ID
          }
        }
        return banner;
      });
    }
  } catch (err) {
    console.error("Slider fetch error", err);
  } finally {
    isLoading.value = false;
  }
};

onBeforeMount(() => {
  isLoading.value = true;
});
onMounted(fetchSliderImages);
</script>

<style lang="scss">
.carousel__viewport {
    height: 100% !important;
    .carousel__track {
        height: 100% !important;
        transition-timing-function: ease-in-out !important;
        // transition: opacity 0.6s ease-in-out, transform 0.8s ease-in-out !important;
        
    }
}
</style>
<style lang="scss" scoped>
.carousel {
  text-align: left !important;
}
.carousel__pagination {
    width: 100%;
    margin: 0 !important;
    position: absolute !important;
    bottom: 3% !important;
}
.carousel__viewport {
    height: 100% !important;
    .carousel__track {
        height: 100% !important;
        
    }
}
@media screen and (max-width: 700px){
    .carousel__pagination {
        left: -6% !important;
    }
}
.carousel__pagination-button {
  display: block;
  border: 0;
  margin: 0;
  cursor: pointer;
  padding: var(--vc-pgn-margin);
  background: red;
  color: #e84f69;
}

.banner-content {
  margin-left: 300px; // keep left alignment like before
  margin-top: 77px;   // same as your title offset
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.banner-title {
  font-size: 52px;
  color: #fff;
  font-weight: 700;
  margin-bottom: 20px; // 👈 spacing between title and button
}

.banner-btn {
  display: inline-block;
  padding: 12px 28px;
  background: #e84f69;
  border-radius: 100px;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: #e27a0f;
    transform: translateY(-2px);
  }
}

</style>